/**
 * Progress container styling utilities
 * Shared styling functions for progress container component
 */

import { Theme } from '@mui/material';
import { PROGRESS_CONTAINER_CONSTANTS } from '../constants/progress-container.constants';

/**
 * Base container styles
 */
export const getProgressContainerStyles = (theme: Theme) => ({
  position: 'relative' as const,
  width: '100%',
  padding: theme.spacing(
    PROGRESS_CONTAINER_CONSTANTS.PADDING.Y,
    PROGRESS_CONTAINER_CONSTANTS.PADDING.X,
  ),
  paddingLeft: 0, // Remove left padding to align with container edge
  overflowX: PROGRESS_CONTAINER_CONSTANTS.OVERFLOW.X,
  overflowY: PROGRESS_CONTAINER_CONSTANTS.OVERFLOW.Y,
  scrollBehavior: 'smooth' as const, // Enable smooth scrolling for active step centering
  minHeight: theme.spacing(PROGRESS_CONTAINER_CONSTANTS.MIN_HEIGHT),
  animation: `progressEntrance ${PROGRESS_CONTAINER_CONSTANTS.ENTRANCE.DURATION} ${PROGRESS_CONTAINER_CONSTANTS.ENTRANCE.EASING}`,
});

/**
 * Scrollbar hiding styles
 */
export const getScrollbarHidingStyles = () => ({
  // Hide scrollbars completely
  scrollbarWidth: 'none' as const, // Firefox
  msOverflowStyle: 'none' as const, // IE and Edge
  '&::-webkit-scrollbar': {
    display: 'none', // Chrome, Safari, Opera
  },
});
